import { SORTING_DIRECTION } from 'src/constants/main';
import { TBooleanInNumber } from 'src/types/main';
import { ICategoryOrProductItem } from 'src/view/containers/Modals/CategoryAndProductModal/CategoryAndProductModal';
import { TPromoBannerValiditySettings } from '../store/types';

export type TPromobanner = {
  id: number;
  name: string;
  image: string;
  start_date: string; // "2021-08-16"
  end_date: string; // "2022-08-16",
  category: ICategoryOrProductItem | null;
  item: ICategoryOrProductItem | null;
  status: TBooleanInNumber; // 1 | 0
  is_delete: number; // 1 | 0
  link?: string;
  is_shown_as_offer?: boolean;
  active_24_hours?: boolean;
  timeslots?: TPromoBannerValiditySettings[];
};

export interface IEditPromobanner {
  name?: string;
  image?: string;
  start_date?: number; // timestamp
  end_date?: number; // timestamp
  category?: ICategoryOrProductItem | null;
  product?: ICategoryOrProductItem | null;
  link?: string;
  target?: PROMOBANNERR_TARGET;
  status?: number; // 1 | 0
  is_shown_as_offer?: boolean;
  active_24_hours?: boolean;
  timeslots?: TPromoBannerValiditySettings[];
}

export interface IPromobannersFilter {
  name?: string;
  end_date?: number; // timestamp
  status?: TBooleanInNumber; // 1 | 0
  is_delete?: number; // 1 | 0
  sort_field?: PROMOBANNER_SORT_COLUMN; // id, name, image, start_date, end_date, category, product, status
  sort_dir?: SORTING_DIRECTION; // asc, desc
}

export enum PROMOBANNER_SORT_COLUMN {
  ID = 'id',
  NAME = 'name',
  IMAGE = 'image',
  START_DATE = 'start_date',
  END_DATE = 'end_date',
  CATEGORY = 'category',
  PRODUCT = 'product',
  STATUS = 'status',
}

export interface IPromobannersIsValid {
  name: boolean;
  image: boolean;
  start_date: boolean;
  all: boolean;
  target: boolean;
}

export enum PROMOBANNERR_TARGET {
  NONE = 'none',
  CATEGORY = 'category',
  ITEM = 'item',
  LINK = 'link',
}
